import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTabs,{staticClass:"tabs",attrs:{"color":"teal","background-color":_vm.backgroundColor,"vertical":_vm.vertical,"slider-size":"7"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }